export const getProducts = (state) => state.products;
